module.exports = __webpack_public_path__ + "img/add-step.ae6cb38f.png";